import { render } from "./Margin.vue?vue&type=template&id=3aaffc88"
import script from "./Margin.vue?vue&type=script&lang=js"
export * from "./Margin.vue?vue&type=script&lang=js"

import "./Margin.vue?vue&type=style&index=0&id=3aaffc88&lang=scss"

import exportComponent from "D:\\Microsoft VS Code Project\\startkit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__